import { NgModule } from '@angular/core';
import { GCCoreModule } from '@core/_core.module';
import { UtilsModule } from '@yourcause/common/utils';
import { AddEditCommunicationComponent } from './add-edit-communication-modal/add-edit-communication-modal.component';
import { CommunicationsModalComponent } from './communications-modal/communications-modal.component';
import { CommunicationsViewComponent } from './communications-view/communications-view.component';
import { ExternalEmailThreadComponent } from './external-email-thread/external-email-thread.component';
import { AccordionsModule } from '@yourcause/common/accordion';

@NgModule({
  imports: [
    GCCoreModule,
    UtilsModule,
    AccordionsModule
  ],
  declarations: [
    CommunicationsViewComponent,
    AddEditCommunicationComponent,
    ExternalEmailThreadComponent,
    CommunicationsModalComponent
  ],
  exports: [
    CommunicationsViewComponent,
    CommunicationsModalComponent
  ]
})
export class CommunicationsModule { }
